<template>
  <div class="w-full p-4 rounded-lg bg-white flex flex-col gap-y-2">
    <div class="flex items-center gap-x-2" v-for="(userInfo, i) in userInfos" :key="i" >
      <p class="w-max border border-blue-400 rounded-xl px-2 bg-blue-400 text-xs text-white leading-6">{{ userInfo.title }}</p>
      <p class="min-w-0 flex-1 text-xs font-bold break-words">{{ userInfo.value }}</p>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'RoomCBTInfoItem',
  props: {
    user: { type: Object }
  },
  computed: {
    ...mapState('cbt', [
      'roomCBT',
    ]),

    userInfos() {
      return [
        { title: '닉네임', value: this.user.username },
        { title: '진행률', value: this.userScore },
      ];
    },
    userScore() {
      const cbtUserQuestionList = this.user.userQuestionList?.filter(userQuestion => {
        if (!userQuestion.userAnswerList?.length || userQuestion.questionType === 'SUBJECTIVE' && userQuestion.userAnswerList[0].answerText === '') {
          return false;
        }
        return true;
      })
      let percent = cbtUserQuestionList?.length / this.roomCBT.questionList?.length * 100 || 0;

      let score = 0;
      this.roomCBT.questionList?.forEach((question, i) => {
        this.user.userQuestionList?.forEach(userQuestion => {
          if (question.questionId === userQuestion.questionId) {
            question.answerList?.forEach((answer, j) => {
              let eachAnswerScore = question.questionScore / question.correctAnswerCnt;
              if (!isFinite(eachAnswerScore)) {
                eachAnswerScore = question.questionScore;
              }

              userQuestion.userAnswerList?.forEach(userAnswer => {
                if (
                  (answer.answerId === userAnswer.answerId && answer.correct) ||
                  (answer.answerText && userAnswer.answerText && answer.answerText === userAnswer.answerText)
                ) {
                  score += eachAnswerScore;
                }
              });
            });
          }
        });
      });

      score = this.formatNumber(score);
      percent = this.formatNumber(percent);

      return `${score}점 ${percent}%`;
    },
    formatNumber: () => x => x % 1 !== 0 ? Number(x.toFixed(2)) : x,
  },
}
</script>